import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Anonymous from './Anonymous';
import Map, {Toggle} from './Map';

const ControlsArea = ({isAnonymous, closed}) => (
    <div className="container">
        <div id="metar-taf-controls" className={classNames({closed})}>
            {isAnonymous ? <Anonymous /> : <Toggle closed={closed} />}
            <Map isAnonymous={isAnonymous} />
        </div>
    </div>
);

const mapStateToProps = ({isAnonymous, mapClosed}) => ({
    closed: mapClosed,
    isAnonymous,
});

export default connect(mapStateToProps)(ControlsArea);
